<template>
  <div class="modal fade update-goal-modal" id="UpdateGoalsModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Editar meta</h1>
                  <button type="button" class="btn-close update-goal-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formUpdateGoal" v-on:submit="updateGoalsMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para atualizar</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="month_goal_update" class="form-label fw-medium"
                      >Mês</label
                    > 
                    <input
                      :value="getCurrentGoals.month"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="month_goal_update"
                      placeholder="Digite o mês"
                      autocomplete="off"
                      disabled
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="year_goal_update" class="form-label fw-medium"
                      >Ano</label
                    >                      
                      <input
                        :value="getCurrentGoals.year"
                        id="year_goal_update"
                        ref="year_update"
                        type="text"
                        class="form-control shadow-none rounded-0 text-black radius-7"
                        placeholder="Digite o ano"
                        disabled
                      />
                  </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                  <label for="password_update" class="form-label fw-medium"
                    >Meta</label
                  >
                  <input
                    type="text"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="goal_value_update"
                    autocomplete="off"
                    v-model="faturamento"
                    @input="maskMoney"
                    placeholder="Ex: 1.150,00"
                    required
                  />
                </div>

                  <div class="col-12">
                    <div id="alertResponseApiUpdateGoals" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageUpdateUser">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger update-goal-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonUpdateGoal" class="btn btn-success">Salvar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapGetters } from 'vuex';

export default {
  name: "UpdateGoalsModal",
  data () {
    return {
      faturamento: null
    }
  },
  computed: {
    ...mapGetters([
      "getRolesList",
      "getCurrentGoals",
      "getOperations"
    ]),
  },
  watch: {
    'getCurrentGoals.phone'(newValue) {
      this.$nextTick(() => {
        this.applyMaskPhone({
          target: this.$refs.year_update
        });
      });
    }
  },
  methods: {
    maskMoney(e) {
      let value = e.target.value;

      value = value.replace(/\D/g, "");

      if (!value) {
        this.faturamento = "";
        return;
      }

      value = (parseInt(value, 10) / 100).toFixed(2);

      value = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);

      this.faturamento = value;
    },
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskPhone(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    updateGoalsMethod(){
      event.preventDefault();
      const alertResponse = this.alertResponse;

      const goal_id = this.getCurrentGoals.id;
      const goal_value_update = document.getElementById("goal_value_update").value;
      
      if(!goal_value_update){
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      const objUserUpdate = {
        "id": goal_id,
        "goal": goal_value_update
      }

      const buttonUpdateGoal = this.$refs.buttonUpdateGoal;
      buttonUpdateGoal.disabled = true;
      buttonUpdateGoal.innerHTML = "Salvando...";
      

      api.axios.post("/api/update/goal", objUserUpdate).catch(function(error){
        if(error.response.data != undefined){
          buttonUpdateGoal.innerHTML = "Salvar";
        }
        console.log("error", error);
        alertResponse(error.response.data.message, true);
      }).then(function(response){
        
        if(response != undefined && response.status == 200){
          buttonUpdateGoal.innerHTML = "Informações salvas com sucesso !";
          window.location.reload();
        } else {
          buttonUpdateGoal.disabled = false;
          buttonUpdateGoal.innerHTML = "Salvar";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageUpdateUser").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageUpdateUser").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiUpdateGoals");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_update");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>